import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo, useRef, useState, } from "react";
import { AccordionContent, AccordionItem, AccordionTrigger } from "../../../../components/shadcn/accordion";
import { motion } from "framer-motion";
import { CurrencySelectItemDisplay } from "../Routes";
import { CollapsableHeader } from "./CollapsableHeader";
import { StickyHeader } from "./StickyHeader";
import clsx from "clsx";
import { NavigatableItem } from "../../../../components/NavigatableList";
export const CollapsibleRow = ({ item, index, toggleContent, direction, onSelect, selectedRoute, selectedToken, searchQuery, openValues, scrollContainerRef, hideBalances, }) => {
    const groupName = item.type === "grouped_token" ? item.symbol : item.route.name;
    const headerId = `${groupName}-header`;
    const childrenList = useMemo(() => {
        if (item.type === "grouped_token") {
            const grouped = item;
            return grouped.items.map((el) => ({
                token: el.route.token,
                route: el.route.route,
            }));
        }
        else {
            const route = item.route;
            return route.tokens.map((t) => ({
                token: t,
                route: route,
            }));
        }
    }, [item]);
    const [isSticky, setSticky] = useState(false);
    const headerRef = useRef(null);
    const contentRef = useRef(null);
    const isOpen = openValues?.some((ov) => ov === groupName);
    const stickyToggle = () => {
        toggleContent(groupName);
        headerRef.current?.scrollIntoView({ block: "start", inline: "start" });
    };
    const setHeaderRef = (el) => {
        headerRef.current = el;
    };
    return (_jsx(motion.div
    //  {...(!searchQuery && { layout: "position" })} 
    , { children: _jsxs(AccordionItem, { value: groupName, children: [_jsx(NavigatableItem, { index: index, onClick: () => toggleContent(groupName), className: clsx("cursor-pointer rounded-lg relative group/accordion hover:bg-secondary-500", isSticky && "opacity-0"), focusedClassName: "bg-secondary-500 is-focused", children: _jsx("div", { ref: setHeaderRef, id: headerId, children: _jsx(AccordionTrigger, { tabIndex: -1, children: _jsx(CollapsableHeader, { item: item, direction: direction, hideTokenImages: isOpen, hideBalances: hideBalances }) }) }) }), _jsx(StickyHeader, { item: item, direction: direction, scrollContainer: scrollContainerRef.current, open: isOpen, headerRef: headerRef, contentRef: contentRef, childrenCount: childrenList?.length, onClick: stickyToggle, isSticky: isSticky, setSticky: setSticky, hideBalances: hideBalances }), _jsx(AccordionContent, { className: "AccordionContent", ref: contentRef, itemsCount: childrenList?.length, children: _jsx("div", { className: "has-[.token-item]:mt-1 bg-secondary-500 rounded-xl overflow-hidden", children: _jsx("div", { className: "overflow-y-auto styled-scroll p-2", children: childrenList?.map(({ token, route }, childIndex) => {
                                const isSelected = selectedRoute === route.name && selectedToken === token.symbol;
                                return (_jsx(TokenItem, { token: token, route: route, childIndex: childIndex, groupName: groupName, parentIndex: index, isSelected: isSelected, direction: direction, onSelect: onSelect, hideBalances: hideBalances }, `${groupName}-${childIndex}`));
                            }) }) }) })] }) }, searchQuery ? "search" : "default"));
};
// Memoized child item to prevent re-renders when siblings change focus
const TokenItem = memo(({ token, route, childIndex, groupName, parentIndex, isSelected, direction, onSelect, hideBalances, }) => {
    const handleClick = useCallback(() => {
        onSelect(route, token);
    }, [onSelect, route, token]);
    return (_jsx(NavigatableItem, { index: childIndex, parentIndex: parentIndex, onClick: handleClick, className: "token-item pl-2 pr-3 cursor-pointer rounded-xl outline-none disabled:cursor-not-allowed hover:bg-secondary-400", focusedClassName: "bg-secondary-400", children: _jsx(CurrencySelectItemDisplay, { item: token, selected: isSelected, route: route, direction: direction, hideBalances: hideBalances }) }, `${groupName}-${childIndex}`));
});
